/* eslint-disable @typescript-eslint/no-explicit-any */
import { walkWidgetConfigTree } from '@juvare/common-form-ui/walkWidgetConfigTree';
export function generateValidateFunction(form, widgets, rule) {
    const dataPaths = [];
    walkWidgetConfigTree(form, widgets, (config, widget, parentDataPath) => {
        // Walk through all widgets and construct proper data path
        let dataPath = joinPaths(parentDataPath, config.key);
        if (widget.childDynamicRows) {
            // For data grid like components will need to check all array values, use special # key
            // See function expandDataGridPath in src/Backend/Entities/AccountSection/validate.ts
            dataPath = joinPaths(dataPath, '#');
        }
        if (config.rules && config.rules.includes(rule)) {
            // The rule validateAccountCompletion acts as the flag we need to consider before constructing the function
            dataPaths.push(dataPath);
        }
        return dataPath;
    });
    if (dataPaths.length > 0) {
        const accountCompletionFunctionValidation = '{\n' +
            "    if (Array.isArray(value) || typeof value === 'string') {\n" +
            '        return !!value.length;\n' +
            "    } else if (typeof value === 'boolean') {\n" +
            '        return true;\n' +
            '    }\n' +
            '    return value != null;\n' +
            '}';
        const functionValidation = rule === 'validateAccountCompletion' ? accountCompletionFunctionValidation : '!!value';
        return ('// These fields were added automatically based on ' +
            rule +
            ' rule.\n' +
            'const dataPaths = [\n' +
            dataPaths.map((p) => "    '" + p + "'").join(',\n') +
            ',\n];\n\n' +
            '// Calculate result based on fields above.\n' +
            'return {\n' +
            `    incompleteFields: dataPaths.filter(dataPath => !checkDataValueExists(data, dataPath, (value) => ${functionValidation})),\n` +
            '    validatedFieldCount: dataPaths.length,\n' +
            '};\n');
    }
    else {
        return ('// No fields with ' +
            rule +
            ' rule found.\n' +
            'return {\n' +
            '    incompleteFields: [],\n' +
            '    validatedFieldCount: 0,\n' +
            '};\n');
    }
}
function joinPaths(parentDataPath, childDataPath) {
    const parent = !!parentDataPath;
    const child = !!childDataPath;
    if (parent && child) {
        return parentDataPath + '.' + childDataPath;
    }
    else if (parent) {
        return parentDataPath;
    }
    else if (child) {
        return childDataPath;
    }
    else {
        return '';
    }
}
